// Dumb dialog — no store, no SQL, no API, no analytics.
//
//   props:  modelValue        (Boolean) v-model for the open state
//           teamUsers         (Object)  { [teamId]: [{ id, displayName, avatarUrl, roleTitle }] }
//           selectedTeam      (Array)   v-model; the page's team selection
//           selectedSubItems  (Array)   v-model; sub-item ids to assign
//           allItems          (Array)   the FULL item list, used only for the
//                                       per-user badge counts (R13 — the PUT
//                                       loop runs in the page against ITS list)
//           assigning         (Boolean) shows the "Assigning items..." overlay
//   emits:  update:modelValue, update:selectedTeam, update:selectedSubItems
//           assign({ teamId, userIds, subItemIds })  the page performs the PUT
import setup from './setup.js';

export default {
  name: 'team-assignment-dialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    teamUsers: {
      type: Object,
      default: () => ({})
    },
    selectedTeam: {
      type: Array,
      default: () => []
    },
    selectedSubItems: {
      type: Array,
      default: () => []
    },
    allItems: {
      type: Array,
      default: () => []
    },
    assigning: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue',
    'update:selectedTeam',
    'update:selectedSubItems',
    'assign'
  ],
  setup,
};
